/**
 * Date helpers, in one place (react-pwa-engineering skill 6.2).
 *
 * Two kinds of value live side by side in this app and must not be confused: a date the user
 * picked (`YYYY-MM-DD`, no timezone) and an instant the ledger stores (`timestamptz`). These
 * functions are the only place one becomes the other.
 */

/** Today as a date input wants it, in the household timezone — not the device's. */
export function todayInputValue(timeZone: string): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
}

/**
 * The instant to store for a date the user picked.
 *
 * Midday UTC, not midnight: it lands inside the chosen day for every timezone from UTC-11 to
 * UTC+11 (Asia/Ho_Chi_Minh has five hours to spare), so a report cutting months in the
 * household timezone files it under the day the user meant. Midnight UTC would move the
 * entry to the previous day for any household east of Greenwich.
 */
export function instantForDate(dateInput: string): string {
  return new Date(`${dateInput}T12:00:00Z`).toISOString();
}

/**
 * The instant for a transaction dated `dateInput`: the real clock time when that is today,
 * so the timeline shows when it happened, and midday otherwise.
 */
export function instantForTransactionDate(dateInput: string, timeZone: string): string {
  return dateInput === todayInputValue(timeZone)
    ? new Date().toISOString()
    : instantForDate(dateInput);
}
